import EntityModel from "models/EntityModel";
import ModulePaperlessApplicationFlowModel from "models/ModulePaperlessApplicationFlowModel";
import styles from "modules/paperless-onboarding/css/PaperlessOnBoarding.css";
import ApplicationOverlay from "modules/shared/components/top/ApplicationOverlay";
import ApplicationProgressDots from "modules/shared/components/widgets/static/ApplicationProgressDots";
import Loader from "modules/shared/components/widgets/static/Loader";
import React, { useEffect, useState } from "react";
import { browserHistory } from "react-router";

import { componentFactory } from "../index";

const flow = ["email-verification", "details", "authorisation", "complete"];
const progressDotLables = ["Details", "Authorisation"];

function usePaperlessApplicationRecord() {
  const [paperlessApplication, setPaperlessApplication] = useState(
    new ModulePaperlessApplicationFlowModel(),
  );

  return { paperlessApplication, setPaperlessApplication };
}

function useSupplierRecord(supplierId) {
  const [supplier, setSupplier] = useState(new EntityModel({ id: supplierId }));

  return { setSupplier, supplier };
}

export default function PaperlessOnBoarding(props) {
  const { params, location } = props;

  const [currentSectionIndex, setCurrentSectionIndex] = useState(0);
  const [showLoading, setShowLoading] = useState(false);
  const {
    paperlessApplication,
    setPaperlessApplication,
  } = usePaperlessApplicationRecord();
  const { supplier, setSupplier } = useSupplierRecord(params.supplier_id);

  const redirect = sectionIndex => {
    browserHistory.push({
      pathname: `/paperless/${params.supplier_id}/${flow[sectionIndex]}`,
      query: {
        code: paperlessApplication.attributes.verification_code,
        email: paperlessApplication.attributes.email,
      },
    });
  };

  const links = progressDotLables.map(sectionLable => {
    return { label: sectionLable };
  });

  const toNextSection = () => {
    setCurrentSectionIndex(currentSectionIndex + 1);
    redirect(currentSectionIndex + 1);
  };

  const toPrevSection = () => {
    setCurrentSectionIndex(currentSectionIndex - 1);
    redirect(currentSectionIndex - 1);
  };

  useEffect(() => {
    setShowLoading(true);
    (async() => {
      await supplier.getLogoAndTheme();
      const query = props.location.query;
      if (query.email && query.code) {
        const emailAndCode = {
          email: query.email,
          verificationCode: query.code,
        };
        paperlessApplication.setAttributes(emailAndCode);
        const result = await paperlessApplication.validateCode();
        if (result.data.valid) {
          await paperlessApplication.load(params.supplier_id);
          setCurrentSectionIndex(1);
          redirect(1);
        }
      }
      setShowLoading(false);
    })();
  }, []);

  const childComponentProps = {
    location,
    paperlessApplication,
    supplierId: props.params.supplier_id,
    supplierLogoUrl: supplier.attributes.logo_url,
    toNextSection,
    toPrevSection,
  };

  let childComponent = <Loader />;
  if (!showLoading) {
    if (supplier.attributes.paperless_flow_enable) {
      childComponent = componentFactory(
        flow[currentSectionIndex],
        childComponentProps,
      );
    } else {
      childComponent = (
        <div className={styles.disabled_hint}>
          <div className={styles.hint_text}>
            {"Direct debit authorisation disabled by supplier"}
          </div>
        </div>
      );
    }
  }

  return (
    <div className={styles.container}>
      <div className={styles.application_content}>
        {[1, 2].includes(currentSectionIndex) && (
          <div className={styles.controls}>
            <ApplicationOverlay
              trading_name={supplier.attributes.trading_name}
              logo_url={supplier.attributes.logo_url}
              label={"Direct debit authorisation"}
            />
            <ApplicationProgressDots
              type="horizontal"
              index={currentSectionIndex - 1}
              links={links}
            />
          </div>
        )}
        {childComponent}
      </div>
    </div>
  );
}
